module.exports = __webpack_public_path__ + "static/kontaktbg-841107c957f4933f05aa28f5ede99c61.jpg";